import { localize } from './L10n';

let studyplanId = null;

// Study-plan module swatches. The FHGR-2026 brand ships 4 colors (Graphite,
// Silver, Lagoon, Ruby) but this legend needs 5 distinct swatches, so `elective`
// and `practice_project` are lightened tints of their sibling brand color.
export const moduleTypes = {
  compulsory: {
    label: localize('moduleTypeCompulsory'),
    color: '#008C80', // Lagoon
  },
  core_elective: {
    label: localize('moduleTypeCoreElective'),
    color: '#38484E', // Graphite
  },
  elective: {
    label: localize('moduleTypeElective'),
    color: '#7A8B90', // Graphite tint
  },
  thesis: {
    label: localize('moduleTypeThesis'),
    color: '#D61E38', // Ruby
  },
  practice_project: {
    label: localize('moduleTypePracticeProject'),
    color: '#EA818D', // Ruby tint
  },
  laboratory: {
    label: localize('moduleTypeLaboratory'),
    color: '#D61E38', // Ruby (grouped with thesis, as before)
  },
  research_methods: {
    label: localize('moduleTypeResearchMethods'),
    color: '#D61E38', // Ruby (grouped with thesis, as before)
  },
};

export const PLACEHOLDER_TYPE_NONE = 0;
export const PLACEHOLDER_TYPE_CORE_ELECTIVE = 1;
export const PLACEHOLDER_TYPE_ELECTIVE = 2;

export const getTypeFromModule = function (module) {
  let type = module.type;

  if (module.placeholderType === PLACEHOLDER_TYPE_CORE_ELECTIVE) {
    type = 'core_elective';
  }

  if (module.placeholderType === PLACEHOLDER_TYPE_ELECTIVE) {
    type = 'elective';
  }

  return [type, moduleTypes[type]];
};

export const setStudyplanId = (id) => {
  studyplanId = id;
};

export const getStorage = () => {
  const selectedModules = sessionStorage.getItem(`modules-${studyplanId}`);
  if (selectedModules) {
    return JSON.parse(selectedModules);
  }
  return [];
};
export const getSessionModules = (semester, emptyObject = true) => {
  const selectedModules = getStorage();
  if (selectedModules) {
    const { [semester]: semesterValue } = selectedModules;
    if (semesterValue) {
      return {
        selected: Object.values(semesterValue),
        dropzone: semesterValue,
      };
    }
  }
  if (emptyObject) {
    return {
      selected: [],
      dropzone: {},
    };
  }
};
export const setSessionModules = (state, semester) => {
  const storage = getStorage();

  sessionStorage.setItem(
    `modules-${studyplanId}`,
    JSON.stringify({
      ...(storage ? storage : {}),
      [semester]: state.dropzone,
    })
  );
};

export const setSession = (session) => {
  sessionStorage.setItem(`modules-${studyplanId}`, JSON.stringify(session));
};
